import React from 'react';
import { formatNumber, getCurrencySymbol } from '../../../common/Formatter';
import { InstallmentPrice } from '../../../common/ProductMethods';
import { useTranslation } from 'react-i18next';

type InstallmentPaymentDisplayProps = {
  style: string;
  text: string;
  priceMonthly: InstallmentPrice;
  culture: string;
};

const InstallmentPaymentDisplay = ({
  style,
  text,
  priceMonthly,
  culture
}: InstallmentPaymentDisplayProps): JSX.Element => {
  const { t } = useTranslation();
  const installmentPerMonthText = t(
    'renewals-quote.installment-per-month-text'
  );
  const installmentsPaymentsOfText = t(
    'renewals-quote.installments-payments-of-text'
  );
  return (
    <>
      <p>
        <span>
          {' '}
          {priceMonthly.totalNumberOfInstallments}
          {installmentsPaymentsOfText}
        </span>
        <span className={style}>
          {`${text}${getCurrencySymbol()}${formatNumber(
            priceMonthly.firstInstallmentPrice,
            2,
            culture
          )}`}{' '}
        </span>
        <span>{installmentPerMonthText}</span>
      </p>
    </>
  );
};

export default InstallmentPaymentDisplay;
